import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { setPropTypes, compose, withProps } from 'recompose'
import Paginate from '../../../../shared_components/Paginate/Paginate'

const enhance = compose(
  inject('store'),
  withProps(({store}) => ({
    valueState: store.valueStateStore,
    listingType: store.listingTypeStore
  })),
  setPropTypes({
    valueState: PropTypes.object.isRequired,
    listingType: PropTypes.object.isRequired
  }),
  observer
)

const PaginationSelector = enhance(({ valueState }) => {
  return (
    <Paginate
      currentPage={valueState.currentPage}
      totalPages={valueState.totalPages}
      onPageChange={value => {
        valueState.paginate(value)
      }}
    />
  )}
)

export default PaginationSelector
